import React from 'react';
import ContentViewComponent from '../../../../Component/ContentViewComponent/ContentViewComponent';
import { Grid2 as Grid, IconButton, Tooltip } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoutePathname } from '../../../../Handler/RouteHandler';
import TableComponent from '../../../../Component/TableComponent/TableComponent';
import ApiHandler from '../../../../Handler/ApiHandler';
import { Delete, Edit } from '@mui/icons-material';
import moment from 'moment';
import { dispatch } from '../../../../App';
import { TableReload } from '../../../../Reducer/TableReducer/TableSlice';
import { SnackbarOpen } from '../../../../Reducer/SnackBarReducer/SnackBarSlice';
import Swal from "sweetalert2";
import ShadowBoxComponent from '../../../../Component/ShadowBoxComponent/ShadowBoxComponent';
import { initFormHandler } from '../../../../Handler/FormHandler';
import TextFieldComponent from '../../../../Component/TextFieldComponent/TextFieldComponent';
import TitleComponent from '../../../../Component/TitleComponent/TitleComponent';

function CrmCustomerList(props) {
    const [loadingContent, setLoadingContent] = React.useState(true);
    const [breadcrumbs, setBreadcrumbs] = React.useState({});
    const [searchText, setSearchText] = React.useState('');
    const isFirstSearchRender = React.useRef(true);
    const navigate = useNavigate();
    const [form, setForm] = React.useState({
        searchText: {
            name: "searchText",
            label: "Rechercher un client",
            textHelper: "Filtrez par nom, prénom, email ou téléphone.",
            type: "text",
            defaultValue: "",
            options: {},
        },
    });
    const handlerForm = initFormHandler(form, setForm);

    const columns = [
        {
            name: "id",
            label: "Référence",
            options: { filter: true, sort: true }
        },
        {
            name: "firstname",
            label: "Prénom",
            options: { filter: true, sort: true }
        },
        {
            name: "lastname",
            label: "Nom",
            options: { filter: true, sort: true }
        },
        {
            name: "email",
            label: "Email",
            options: { filter: true, sort: true }
        },
        {
            name: "telephone",
            label: "Téléphone",
            options: { filter: true, sort: true }
        },
        {
            name: "createdAt",
            label: "Date de création",
            options: { filter: true, sort: true }
        },
        {
            name: "deletedAt",
            label: "Date de suppression",
            options: { filter: true, sort: true }
        },
        {
            name: "action",
            label: "Action",
            options: { filter: false, sort: false }
        }
    ];

    React.useEffect(() => {
        handlerForm.start();
    }, [handlerForm]);

    React.useEffect(() => {
        setBreadcrumbs({
            title: 'CRM',
            context: 'Liste des clients',
            description: '',
            links: []
        });

        setTimeout(() => {
            setLoadingContent(false);
        }, 1500);
    }, []);

    React.useEffect(() => {
        if (isFirstSearchRender.current) {
            isFirstSearchRender.current = false;
            return;
        }

        const timeout = setTimeout(() => {
            dispatch(TableReload("crm_customer_list"));
        }, 300);

        return () => clearTimeout(timeout);
    }, [searchText]);

    const getAction = (row) => {
        return (
            <>
                <div style={{ display: 'flex' }}>
                    <Tooltip title={"Éditer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                navigate(getRoutePathname('crm_customer', { id: row.id }))
                            }}>
                            <Edit />
                        </IconButton>
                    </Tooltip>
                    <Tooltip title={"Supprimer"} placement="left" arrow>
                        <IconButton
                            onClick={() => {
                                let username = row.lastname + ' ' + row.firstname;
                                Swal.fire({
                                    title: "Êtes-vous sûr de vouloir supprimer " + username + " ?",
                                    text: "",
                                    icon: "warning",
                                    showCancelButton: true,
                                    confirmButtonColor: "#87bba4",
                                    cancelButtonColor: "var(--greytext)",
                                    confirmButtonText: "Confirmer",
                                    cancelButtonText: "Annuler",
                                    reverseButtons: true,
                                }).then((result) => {
                                    if (result.isConfirmed) {
                                        ApiHandler.delete(
                                            {
                                                route: "crm_customer_delete",
                                                params: { id: row.id },
                                            },
                                            (response) => {
                                                if (response.status === 200) {
                                                    dispatch(TableReload("crm_customer_list"));
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text: "Client supprimé avec succès",
                                                            variant: "success",
                                                        }),
                                                    );
                                                } else {
                                                    dispatch(
                                                        SnackbarOpen({
                                                            text:
                                                                response.error && response.error.message
                                                                    ? response.error.message
                                                                    : "Une erreur inattendu s'est produite.",
                                                            variant: "error",
                                                        }),
                                                    );
                                                }
                                            },
                                        );
                                    }
                                });
                            }}>
                            <Delete />
                        </IconButton>
                    </Tooltip>
                </div>
            </>
        );
    };

    return (
        <ContentViewComponent loading={loadingContent} breadcrumbs={breadcrumbs}>
            <ShadowBoxComponent style={{ marginBottom: 16 }}>
                <TitleComponent title='Filtres'/>
                <Grid container spacing={1}>
                    <Grid size={{ xs: 12 }}>
                        <TextFieldComponent
                            id={"searchText"}
                            handler={handlerForm}
                            onChange={(value) => setSearchText(value || '')}
                        />
                    </Grid>
                </Grid>
            </ShadowBoxComponent>
            <TableComponent
                id={'crm_customer_list'}
                title={'Clients'}
                mobileMode={'cards'}
                columns={columns}
                search={false}
                actionFirst={{
                    label: "Ajouter un client",
                    onClick: () => { navigate(getRoutePathname('crm_customer', { id: 'add' })) },
                }}
                promiseServerData={(resolve, options) => {
                    let filters = {
                        limit: options.rowsPerPage,
                        offset: options.page * options.rowsPerPage,
                        sortName: options.sortOrder.name,
                        sortDirection: options.sortOrder.direction,
                        searchText: searchText.trim(),
                    };

                    ApiHandler.get({
                        route: 'crm_customer_list',
                        data: filters
                    },
                        (response) => {
                            let data = response.data.data;
                            for (let index in data) {
                                data[index].action = getAction(data[index]);
                                data[index].telephone = data[index].telephone || '-';
                                data[index].createdAt = data[index].createdAt ? moment(data[index].createdAt).format('ll') : '-';
                                data[index].deletedAt = data[index].deletedAt ? moment(data[index].deletedAt).format('ll') : '-';
                            }
                            resolve(data, response.data.count);
                        });
                }}
            />
        </ContentViewComponent>
    );
}

export default CrmCustomerList;
